// --------------------------------------------------------------------------
// quoteSlider.js
// --------------------------------------------------------------------------

RN.quoteSlider = function() {

  'use strict';

  function init() {
    byBehaviour('quote-slider').slick({
        dots: true,
        autoplay: true,
        autoplaySpeed: 10000
    });
  }

  return {
    init: init
  };

}();
